import { useAppSelector } from "shared/lib/store";
import { selectTimeslotsMap } from "../../model/selectors";
import { getTimeslotByHours, getTimeslotByMinutesRange } from "../helpers/find/findTimeslots";
import { useTimeslotZone } from "./useTimeslotZone";
import { useGetSlotsByDate } from "features/hallmapToolbar/datePicker/lib/useGetSlotsByDate";
import { useTimeslot } from "./useTimeslot";

export const useCurrentTimeslot = () => {
    const currentDate = new Date();
    const timeslotsMap = useAppSelector(selectTimeslotsMap);
    const hours = currentDate.getHours().toString();
    const { formatISODateBySlotZone } = useTimeslotZone();
    const { getSlotsByDate } = useGetSlotsByDate();
    const { toTimeslot } = useTimeslot();

    const toCurrentTimeslot = async () => {
        const slotsByHours = getTimeslotByHours(timeslotsMap, hours);

        if (!slotsByHours) {
            return false;
        }

        const slotByTime = getTimeslotByMinutesRange(
            slotsByHours,
            currentDate,
        );

        if (!slotByTime) {
            return false;
        }

        const newTimeslotDate = new Date(slotByTime.dt_start);

        if (!currentDate) {
            return false;
        }

        newTimeslotDate.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

        toTimeslot(formatISODateBySlotZone(newTimeslotDate), { hours, clear: true });

        await getSlotsByDate(currentDate);
        return true;
    }

    const getCurrentTimeSlot = () => {
      const slotsByHours = getTimeslotByHours(timeslotsMap, hours);
      if (!slotsByHours) {
        return false;
      }

      const slotByTime = getTimeslotByMinutesRange(
          slotsByHours,
          currentDate,
      );

      return slotByTime;
    }

    return {
        toCurrentTimeslot,
        getCurrentTimeSlot
    }
}